import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BaseService } from '@app/core/services/base/base.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { share } from 'rxjs/operators';
import * as _ from 'lodash-es';


export enum ScreenSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl'
}

@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService extends BaseService {
    public bootstrapScreenSize: ScreenSize;
    private _bootstrapScreenSizeObservable: Observable<ScreenSize>;
    private unsubscribeListenerFn: () => void;
    private renderer: Renderer2;

    get bootstrapScreenSizeObservable() {
        if (!this._bootstrapScreenSizeObservable) {
            this.activate();
        }

        return this._bootstrapScreenSizeObservable;
    }

    constructor(private rendererFactory: RendererFactory2) {
        super();
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    private activate(): void {
        this._bootstrapScreenSizeObservable = new Observable((observer) => {

            this.getBootstrapScreenSize();
            observer.next(this.bootstrapScreenSize);

            // subscribe
            this.unsubscribeListenerFn = this.renderer.listen('window', "resize", () => {
                this.getBootstrapScreenSize();
                observer.next(this.bootstrapScreenSize);
            });

            return () => {
                this.unsubscribeListenerFn();
                this.unsubscribeListenerFn = null;
                this._bootstrapScreenSizeObservable = null;
                this.bootstrapScreenSize = null;
            };

        }).pipe(share()) as Observable<ScreenSize>;
    }

    private getBootstrapScreenSize(): ScreenSize {
        const sizerElement = document.getElementById('sizer');
        const children = sizerElement && sizerElement.children;

        const visibleChild = _.find(children, (el) => {
            return el.offsetWidth > 0 && el.offsetHeight > 0;
        });

        const newSize = visibleChild && visibleChild.dataset && visibleChild.dataset.size;

        if (!environment.production && newSize && newSize !== this.bootstrapScreenSize) {
            console.log(`${this.bootstrapScreenSize ? 'Screen resized to' : 'Initial screensize'}: ${newSize}`);
        }

        this.bootstrapScreenSize = newSize;
        return this.bootstrapScreenSize;
    }
}
